<template>
  <div>
    <h2 class="mt-5">Development Objectives</h2>
    <placements-development-item-read-only v-for="objective in objectives" :objective="objective" :key="objective.id"/>
  </div>
</template>

<script>
import { placementDevelopmentObjectiveComputed, placementDevelopmentObjectiveMethods, placementComputed } from 'vx/helpers'
import PlacementsDevelopmentItemReadOnly from './PlacementsDevelopmentItemReadOnly'

export default {
  components: {
    PlacementsDevelopmentItemReadOnly
  },

  computed: {
    ...placementDevelopmentObjectiveComputed,
    ...placementComputed
  },

  async created () {
    await this.getDevelopmentObjectives()
  },

  methods: {
    ...placementDevelopmentObjectiveMethods
  }
}
</script>
